namespace TabAurous.Production {
    export namespace WorkOrderforJWService {
        export const baseUrl = 'Production/WorkOrderforJW';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WorkOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RefListforJobWorkList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WorkOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WorkOrderforJW/List",
            RefListforJobWorkList = "Production/WorkOrderforJW/RefListforJobWorkList"
        }

        [
            'List', 
            'RefListforJobWorkList'
        ].forEach(x => {
            (<any>WorkOrderforJWService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
